<form #form="ngForm"
      method="POST">
    @if (!coupon) {
    <!-- collapsed -->
    <div class="w-12 bg-col-51"
         zippyName="tab">
        <div class="w-12 pos-relative">
            <!-- 'offer' tab header -->
            <div class="cursor-pointer flex flex-middle flex-justify-between p-a-2"
                 [zippyToggle]="['tab','offer']"
                 zippyClass="is-open">
                <span class="p2">{{'Have you got a promo code?' | translate}}</span>
                <i class="icon-plus-animate fs-4 m-r-1"></i>
            </div>
            <!-- content: offer -->
            <div class="ng-hide-animate"
                 [zippyHideUp]="['tab','offer']"
                 zippyAnimationDuration="350">
                <div class="form-small p-a-2 p-b-10">
                    <!-- coupon code -->
                    <input-wrap class="no-validation-icon">
                        <input class="input"
                               type="text"
                               name="coupon"
                               data-hj-allow
                               required
                               (keydown.enter)="submit()"
                               [(ngModel)]="data.coupon"
                               [muiInput]="'Enter offer code' | translate">
                    </input-wrap>
                    <div class="m-t pos-relative">
                        <!-- submit -->
                        <div class="c-12-set m-r-0 m-b-2">
                            <div class="w-6 p-r-1">
                                <action class="w-12 button"
                                        (click)="submit()"
                                        [status]="status">
                                    <span>{{'Apply' | translate}}</span>
                                </action>
                            </div>
                            <div class="w-6 p-l-1">
                                <button class="w-12 button-1"
                                        type="button"
                                        [zippyToggle]="['tab','offer']">
                                    <span>{{'Cancel' | translate}}</span>
                                </button>
                            </div>
                        </div>
                        <div class="pos-absolute left-0 top-100 col-2 s1 m-t--1">
                            @if (errorOverride) {
                            <p>{{errorOverride | translate}}</p>
                            } @else {
                            <result class="c1"
                                    [status]="status"></result>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    }
    @if (coupon) {
    <div class="m-t">
        <p class="m-b-2">
            <span>{{'Voucher' | translate}} </span><span class="fw-bold">{{couponLabel}}</span>
            <span> {{'has been applied' | translate}}
            </span>
        </p>
        <!-- remove coupon -->
        <action (click)="remove()"
                [status]="status"
                class="button-inline underline tt-none fs-4"><span>{{'Click here to remove' | translate}}</span>
        </action>
        <result class="block col-2 fs-3 m-t-1"
                [status]="status"></result>
    </div>
    }
</form>